import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

interface CustomerListActionsProps {
  totalCustomers: number;
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onItemsPerPageChange: (items: number) => void;
}

const CustomerListActions: React.FC<CustomerListActionsProps> = ({
  totalCustomers,
  currentPage,
  totalPages,
  itemsPerPage,
  onPreviousPage,
  onNextPage,
  onItemsPerPageChange,
}) => {
  return (
    <div className="customer-list-actions">
      <div className="pagination-info">
        <span>Total: {totalCustomers} customers</span>
      </div>

      <div className="pagination-controls">
        <button
          className="pagination-btn"
          onClick={onPreviousPage}
          disabled={currentPage === 1}
        >
          <FiChevronLeft />
          Previous
        </button>

        <span className="page-indicator">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="pagination-btn"
          onClick={onNextPage}
          disabled={currentPage === totalPages}
        >
          Next
          <FiChevronRight />
        </button>
      </div>

      <div className="items-per-page">
        <label>Items per page:</label>
        <select
          className="items-select"
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          value={itemsPerPage}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};

export default CustomerListActions;
